<template>
  <ViceButton
    @click="handleDermatoscopeConnection"
    circle
    white
    :showNotification="isActive"
    style="padding: 0 !important"
    :btnDescription="btnDescription"
    :class="{ 'sm:bg-vice-teal-600 hover:bg-vice-teal-700': isActive }"
    class="w-12 h-12 border-none bg-vice-light-grey"
    :disabled="isConnected || loading"
  >
    <ViceLoader colorClass="text-vice-teal-700" class="left-2" v-if="loading" />

    <template v-else>
      <ViceDermatoscope class="w-11 h-11" :pathFill="!isActive ? '#0F766E' : '#fff'" />
    </template>
  </ViceButton>
</template>

<script>
import { computed, ref } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ViceDermatoscope from '../Icons/ViceDermatoscope.vue';
import ViceLoader from '../Loaders/ViceLoader.vue';
import { DERMATOSCOPE_LABELS, EXTERNAL_CONNECTED_VIDEO_DEVICES } from '@/Utils/vice-constants';

export default {
  name: 'AddDermatoscopeButton',
  components: {
    ViceButton,
    ViceDermatoscope,
    ViceLoader,
  },
  setup() {
    const loading = ref(false);
    const multiCameraDevicesStore = useLocalStreamingDevicesStore();
    const sessionStore = useSessionStore();
    const isActive = computed(() =>
      multiCameraDevicesStore.allExternalConnectedVideoDevices.find(
        (deviceName) => deviceName === EXTERNAL_CONNECTED_VIDEO_DEVICES.DERMATOSCOPE,
      ),
    );
    const isConnected = computed(
      () =>
        !multiCameraDevicesStore.groupedDeviceAsAudioAndVideo.VIDEO.Camera.find((device) =>
          DERMATOSCOPE_LABELS.some((singleLabel) => device.label.includes(singleLabel)),
        ),
    );

    const btnDescription = computed(() =>
      isActive.value
        ? `Disconnect ${EXTERNAL_CONNECTED_VIDEO_DEVICES.DERMATOSCOPE}`
        : `Connect ${EXTERNAL_CONNECTED_VIDEO_DEVICES.DERMATOSCOPE}`,
    );

    const handleDermatoscopeConnection = async () => {
      try {
        loading.value = true;
        sessionStore.toggleControlPanel(true);

        if (isActive.value) {
          await multiCameraDevicesStore.removeExternalVideoDevice(
            EXTERNAL_CONNECTED_VIDEO_DEVICES.DERMATOSCOPE,
          );
        } else {
          await multiCameraDevicesStore.addExternalVideoDevice(
            sessionStore.sessionId,
            EXTERNAL_CONNECTED_VIDEO_DEVICES.DERMATOSCOPE,
            DERMATOSCOPE_LABELS,
          );
        }
        multiCameraDevicesStore.markSessionSetupAsChanged();
      } catch (error) {
        console.error({ error });
      } finally {
        loading.value = false;
      }
    };

    return {
      isConnected,
      isActive,
      loading,
      btnDescription,
      handleDermatoscopeConnection,
    };
  },
};
</script>
